var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroupiconred(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 27.996,
    viewBox: "0 0 28 27.996",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1662",
    "data-name": "Group 1662",
    transform: "translate(487.95 -126.943)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3858",
    "data-name": "Path 3858",
    d: "M-422.05,414.333c-2.324,0-4.648.006-6.971,0a4.2,4.2,0,0,1-2.538-.783,3.532,3.532,0,0,1-1.475-2.8,15.1,15.1,0,0,1,.758-5.728,5.927,5.927,0,0,1,1.782-2.732,4.273,4.273,0,0,1,2.732-.942,1.253,1.253,0,0,1,.6.222c.437.262.846.569,1.285.827a7.081,7.081,0,0,0,7.557.055,5.972,5.972,0,0,0,.978-.647,2.083,2.083,0,0,1,2-.343,4.607,4.607,0,0,1,3.135,2.693,10.321,10.321,0,0,1,.962,3.42,25.607,25.607,0,0,1,.17,2.887,3.689,3.689,0,0,1-3.46,3.829,7.32,7.32,0,0,1-.79.046Q-418.687,414.337-422.05,414.333Z",
    transform: "translate(-51.894 -259.394)",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3859",
    "data-name": "Path 3859",
    d: "M-335.778,211.988a5.986,5.986,0,0,1-6.016-5.99,6,6,0,0,1,5.994-6.014,5.992,5.992,0,0,1,6.017,5.991A5.988,5.988,0,0,1-335.778,211.988Z",
    transform: "translate(-138.163 -69.047)",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3860",
    "data-name": "Path 3860",
    d: "M-461.789,130.936a3.973,3.973,0,0,1-3.974,4,3.981,3.981,0,0,1-4.032-3.971,4,4,0,0,1,3.937-4.018A3.982,3.982,0,0,1-461.789,130.936Z",
    transform: "translate(-17.162 -0.002)",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3861",
    "data-name": "Path 3861",
    d: "M-136.578,134.933a3.973,3.973,0,0,1-4-4,3.983,3.983,0,0,1,4.019-3.987,4,4,0,0,1,3.987,4A3.983,3.983,0,0,1-136.578,134.933Z",
    transform: "translate(-328.378 0)",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3862",
    "data-name": "Path 3862",
    d: "M-125.75,274.643c.565.091,1.107.2,1.655.262a6.076,6.076,0,0,0,3.211-.689c.339-.153.664-.338,1-.506a.962.962,0,0,1,1.147.286.423.423,0,0,1,.051.229c0,2.214,0,4.427.006,6.641a.3.3,0,0,1-.178.3,3.969,3.969,0,0,1-1.945.446c-.6.009-1.2.007-1.8,0a.425.425,0,0,1-.285-.11,5.479,5.479,0,0,0-4.047-1.9A6.956,6.956,0,0,0-125.75,274.643Z",
    transform: "translate(-341.265 -138.662)",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3863",
    "data-name": "Path 3863",
    d: "M-479.694,279.569a5.464,5.464,0,0,0-3.38,1.253,3.17,3.17,0,0,0-.491.472.752.752,0,0,1-.708.293c-.709-.03-1.42-.018-2.13-.047a2.918,2.918,0,0,1-1.392-.429.345.345,0,0,1-.148-.246q-.012-3.348,0-6.7a.438.438,0,0,1,.126-.277.922.922,0,0,1,1.165-.158,9.557,9.557,0,0,0,2.807,1.086,5.864,5.864,0,0,0,2.7-.185l.269-.077A6.964,6.964,0,0,0-479.694,279.569Z",
    transform: "translate(0 -138.634)",
    fill: "#d10a11"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupiconred);
export default __webpack_public_path__ + "static/media/groupiconred.a297eca3a263ffc01997c1710611dc0b.svg";
export { ForwardRef as ReactComponent };